/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const SubOfficeStatus = createEnum('SUB_OFFICE_STATUS', {
  New: 'NEW',
  Active: 'ACTIVE',
  Blocked: 'BLOCKED',
  Deactivated: 'DEACTIVATED',
  InDeletion: 'IN_DELETION',
});

export type SubOfficeStatus = EnumSet<typeof SubOfficeStatus>;
